import { objectIdGenerationState } from './objectIdGenerationState';
/**
 * Get the currently set primary object identity generator
 *
 * @return {ObjectIdGenerator}
 */
export var getPrimaryObjectIdGenerator = function () { return objectIdGenerationState.primaryObjectIdGenerator; };
//# sourceMappingURL=getPrimaryObjectIdGenerator.js.map